// =====================================================================================
// FILE: src/config/operatorBases.js
// 
// Configuration for Operator Portal - aggregates multiple club bases
// Each club has CG Operator View and Ribbon Operator View tables
// 
// To add a new club:
// 1. Add env vars: REACT_APP_OPERATOR_{CLUB}_BASE_ID, _CG_TABLE_ID, _RIBBON_TABLE_ID
// 2. Add entry to OPERATOR_BASES array below
// =====================================================================================

/**
 * Operator Base Configuration
 * 
 * Each club base needs:
 * - baseId: Airtable base ID
 * - cgTableId: CG Operator View table ID  
 * - ribbonTableId: Ribbon Operator View table ID
 * - assetsTableId: Assets table ID (for asset picker)
 * - fixturesTableId: Fixtures table ID (for match selector)
 */

// Build operator bases from environment variables
const buildOperatorBases = () => {
  const bases = [];
  
  // St Kilda (STK) - Primary test club
  if (process.env.REACT_APP_OPERATOR_STK_BASE_ID) {
    bases.push({
      id: 'STK',
      name: 'St Kilda',
      shortName: 'STK',
      baseId: process.env.REACT_APP_OPERATOR_STK_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_STK_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_STK_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_STK_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_STK_FIXTURES_TABLE_ID,
    });
  }
  
  // Carlton (CAR)
  if (process.env.REACT_APP_OPERATOR_CAR_BASE_ID) {
    bases.push({
      id: 'CAR',
      name: 'Carlton',
      shortName: 'CAR',
      baseId: process.env.REACT_APP_OPERATOR_CAR_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_CAR_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_CAR_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_CAR_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_CAR_FIXTURES_TABLE_ID,
    });
  }
  
  // Melbourne (MEL)
  if (process.env.REACT_APP_OPERATOR_MEL_BASE_ID) {
    bases.push({
      id: 'MEL',
      name: 'Melbourne',
      shortName: 'MEL',
      baseId: process.env.REACT_APP_OPERATOR_MEL_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_MEL_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_MEL_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_MEL_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_MEL_FIXTURES_TABLE_ID,
    });
  }
  
  // Richmond (RIC)
  if (process.env.REACT_APP_OPERATOR_RIC_BASE_ID) {
    bases.push({
      id: 'RIC',
      name: 'Richmond',
      shortName: 'RIC',
      baseId: process.env.REACT_APP_OPERATOR_RIC_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_RIC_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_RIC_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_RIC_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_RIC_FIXTURES_TABLE_ID,
    });
  }
  
  // Collingwood (COL)
  if (process.env.REACT_APP_OPERATOR_COL_BASE_ID) {
    bases.push({
      id: 'COL',
      name: 'Collingwood',
      shortName: 'COL',
      baseId: process.env.REACT_APP_OPERATOR_COL_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_COL_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_COL_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_COL_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_COL_FIXTURES_TABLE_ID,
    });
  }
  
  // Essendon (ESS)
  if (process.env.REACT_APP_OPERATOR_ESS_BASE_ID) {
    bases.push({
      id: 'ESS',
      name: 'Essendon',
      shortName: 'ESS',
      baseId: process.env.REACT_APP_OPERATOR_ESS_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_ESS_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_ESS_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_ESS_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_ESS_FIXTURES_TABLE_ID,
    });
  }
  
  // Hawthorn (HAW)
  if (process.env.REACT_APP_OPERATOR_HAW_BASE_ID) {
    bases.push({
      id: 'HAW',
      name: 'Hawthorn',
      shortName: 'HAW',
      baseId: process.env.REACT_APP_OPERATOR_HAW_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_HAW_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_HAW_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_HAW_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_HAW_FIXTURES_TABLE_ID,
    });
  }
  
  // Geelong (GEE)
  if (process.env.REACT_APP_OPERATOR_GEE_BASE_ID) {
    bases.push({
      id: 'GEE',
      name: 'Geelong',
      shortName: 'GEE',
      baseId: process.env.REACT_APP_OPERATOR_GEE_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_GEE_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_GEE_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_GEE_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_GEE_FIXTURES_TABLE_ID,
    });
  }
  
  // North Melbourne (NOR)
  if (process.env.REACT_APP_OPERATOR_NOR_BASE_ID) {
    bases.push({
      id: 'NOR',
      name: 'North Melbourne',
      shortName: 'NOR',
      baseId: process.env.REACT_APP_OPERATOR_NOR_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_NOR_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_NOR_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_NOR_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_NOR_FIXTURES_TABLE_ID,
    });
    // NM alias — some deployments use NM instead of NOR for North Melbourne
    bases.push({
      id: 'NM',
      name: 'North Melbourne',
      shortName: 'NM',
      baseId: process.env.REACT_APP_OPERATOR_NOR_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_NOR_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_NOR_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_NOR_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_NOR_FIXTURES_TABLE_ID,
    });
  }
  
  // Western Bulldogs (WBD)
  if (process.env.REACT_APP_OPERATOR_WBD_BASE_ID) {
    bases.push({
      id: 'WBD',
      name: 'Western Bulldogs',
      shortName: 'WBD',
      baseId: process.env.REACT_APP_OPERATOR_WBD_BASE_ID,
      cgTableId: process.env.REACT_APP_OPERATOR_WBD_CG_TABLE_ID,
      ribbonTableId: process.env.REACT_APP_OPERATOR_WBD_RIBBON_TABLE_ID,
      assetsTableId: process.env.REACT_APP_OPERATOR_WBD_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_OPERATOR_WBD_FIXTURES_TABLE_ID,
    });
  }

  // Fallback: If no operator bases configured, use the main app's base
  // This allows testing operator features with existing club setup
  if (bases.length === 0 && process.env.REACT_APP_AIRTABLE_BASE_ID) {
    console.warn('[OperatorBases] No operator bases configured, using main app base for testing');
    bases.push({
      id: process.env.REACT_APP_DEFAULT_CLUB || 'TEST',
      name: process.env.REACT_APP_DEFAULT_CLUB || 'Test Club',
      shortName: process.env.REACT_APP_DEFAULT_CLUB || 'TEST',
      baseId: process.env.REACT_APP_AIRTABLE_BASE_ID,
      // These would need to be set up in Airtable for operator views
      cgTableId: process.env.REACT_APP_AIRTABLE_CG_OPERATOR_TABLE_ID || null,
      ribbonTableId: process.env.REACT_APP_AIRTABLE_RIBBON_OPERATOR_TABLE_ID || null,
      assetsTableId: process.env.REACT_APP_AIRTABLE_ASSETS_TABLE_ID,
      fixturesTableId: process.env.REACT_APP_AIRTABLE_FIXTURES_TABLE_ID,
    });
  }
  
  return bases;
};

export const OPERATOR_BASES = buildOperatorBases();

// Content types for operator views
export const OPERATOR_CONTENT_TYPES = {
  CG: 'cg',
  RIBBON: 'ribbon',
  TVC: 'tvc',         // TVC Content (In-Game) - uses Match Builder table
  IPTV: 'iptv',       // IPTV - uses Match Builder table
  LED: 'led',         // LED Entitlements - uses Match Builder table
};

// Match Builder table IDs (shared with Operator View for TVC/IPTV/LED)
export const MATCH_BUILDER_TABLES = {
  tvcTableId: process.env.REACT_APP_AIRTABLE_INGAME_TABLE_ID || '',
  iptvTableId: process.env.REACT_APP_AIRTABLE_IPTV_TABLE_ID || '',
  ledTableId: process.env.REACT_APP_AIRTABLE_LEDENTITLEMENTS_TABLE_ID || '',
  baseId: process.env.REACT_APP_AIRTABLE_BASE_ID || '',
};

// Operator-specific field names (matching Airtable schema)
export const OPERATOR_FIELDS = {
  // Common fields
  name: 'Name',
  fixtures: 'Fixtures',
  takeId: 'Take ID',
  clientSponsor: 'Client or Sponsor Name',
  playerNumber: 'Player Number',
  category: 'Category',
  cueId: 'Cue ID',
  venue: 'Venue',
  dropboxUrl: 'Dropbox URL',
  
  // Operator-specific fields
  contentStatus: 'Content Status',
  lumen8Comments: 'Lumen8 Comments',
  clubInstructions: 'Club Instructions',
  sendToWatchFolder: 'Send To Watch Folder',
  builtAtVenue: 'Built at Venue',
  builtAtVenueTime: 'Built at Venue Time',
  lastActionedBy: 'Last Actioned By',
  
  // Asset fields (linked record fields)
  cgContent: 'CG Content',
  ribbonContent: 'Ribbon Content',
  
  // Asset metadata fields (lookups from Assets table)
  lumen8Id: 'Lumen8 ID',           // STK_1KE1E5Y1Q etc
  assetDestination: 'Asset Destination',  // Big Screen – GFX & Videos, MCG-iptv, etc.
  hasAudio: 'Has Audio',
  hasAlpha: 'Has Alpha',
  duration: 'Duration',
};

// Content Status options (for Operator View dropdown)
// Ready for Testing = 🔴 new content needs Xpression ingest
// Ready for Playout = 🟢 already in Xpression
// Content Unlocked = 🔓 content has been unlocked for editing
export const CONTENT_STATUS_OPTIONS = [
  'Ready for Testing',
  'Rejected',
  'Approved by Lumen8',
  'Content Unlocked',
];

// Statuses that lock editing in MatchFlow Builder
// ONLY "Approved by Lumen8" locks the row
export const LOCKED_STATUSES = [
  'Approved by Lumen8',
];

// Statuses hidden from Operator Dashboard (Example Content is a placeholder, not real content)
export const HIDDEN_FROM_OPERATOR = ['Example Content'];

// Status colors for conditional formatting
export const CONTENT_STATUS_COLORS = {
  'New Submission': { 
    bg: 'rgba(161, 161, 170, 0.1)',
    text: '#a1a1aa', 
    border: 'rgba(161, 161, 170, 0.3)' 
  },
  'Ready for Testing': { 
    bg: 'rgba(251, 146, 60, 0.1)',  // Orange - new content needs ingest
    text: '#fb923c', 
    border: 'rgba(251, 146, 60, 0.3)' 
  },
  'Ready for Playout': { 
    bg: 'rgba(59, 130, 246, 0.1)',  // Blue - already in Xpression
    text: '#3b82f6', 
    border: 'rgba(59, 130, 246, 0.3)' 
  },
  'Rejected': { 
    bg: 'rgba(239, 68, 68, 0.1)',
    text: '#ef4444', 
    border: 'rgba(239, 68, 68, 0.3)' 
  },
  'Approved by Lumen8': { 
    bg: 'rgba(34, 197, 94, 0.1)',
    text: '#22c55e', 
    border: 'rgba(34, 197, 94, 0.3)' 
  },
  'Content Unlocked': { 
    bg: 'rgba(168, 85, 247, 0.1)',  // Purple - unlocked for editing
    text: '#a855f7', 
    border: 'rgba(168, 85, 247, 0.3)' 
  },
};

// Helper: Get base config by ID
export const getOperatorBase = (clubId) => {
  return OPERATOR_BASES.find(b => b.id === clubId) || null;
};

// Helper: Get table ID for content type
// For CG/Ribbon: uses club-specific operator view tables
// For TVC/IPTV/LED: uses shared Match Builder tables (same for all clubs)
export const getOperatorTableId = (clubId, contentType) => {
  const base = getOperatorBase(clubId);
  
  switch (contentType) {
    case OPERATOR_CONTENT_TYPES.CG:
      return base?.cgTableId || null;
    case OPERATOR_CONTENT_TYPES.RIBBON:
      return base?.ribbonTableId || null;
    case OPERATOR_CONTENT_TYPES.TVC:
      return MATCH_BUILDER_TABLES.tvcTableId || null;
    case OPERATOR_CONTENT_TYPES.IPTV:
      return MATCH_BUILDER_TABLES.iptvTableId || null;
    case OPERATOR_CONTENT_TYPES.LED:
      return MATCH_BUILDER_TABLES.ledTableId || null;
    default:
      return null;
  }
};

// Helper: Get base ID for content type
// For CG/Ribbon: uses club-specific base
// For TVC/IPTV/LED: uses shared Match Builder base
export const getOperatorBaseId = (clubId, contentType) => {
  switch (contentType) {
    case OPERATOR_CONTENT_TYPES.CG:
    case OPERATOR_CONTENT_TYPES.RIBBON:
      const base = getOperatorBase(clubId);
      return base?.baseId || null;
    case OPERATOR_CONTENT_TYPES.TVC:
    case OPERATOR_CONTENT_TYPES.IPTV:
    case OPERATOR_CONTENT_TYPES.LED:
      return MATCH_BUILDER_TABLES.baseId || null;
    default:
      return null;
  }
};

// Helper: Check if operator portal is configured
export const isOperatorConfigured = () => {
  return OPERATOR_BASES.length > 0 && OPERATOR_BASES.some(b => b.cgTableId || b.ribbonTableId);
};

// Helper: Check if a content type uses shared Match Builder tables
export const isSharedTable = (contentType) => {
  return [
    OPERATOR_CONTENT_TYPES.TVC,
    OPERATOR_CONTENT_TYPES.IPTV,
    OPERATOR_CONTENT_TYPES.LED,
  ].includes(contentType);
};

export default OPERATOR_BASES;
